import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdg = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "nonzero",
		d: "M4 15.844c0-.466.447-.844.998-.844H13l-.001-3.7a2 2 0 0 1-.24-3.3H10.03C9.46 8 9 7.54 9 6.971V1.03A1.03 1.03 0 0 1 10.03 0h7.94C18.538 0 19 .46 19 1.029V6.97A1.03 1.03 0 0 1 17.97 8H15.24A2 2 0 0 1 15 11.3V15h8.002c.551 0 .998.378.998.844V20h2.97c.569 0 1.03.46 1.03 1.029v5.942A1.03 1.03 0 0 1 26.97 28h-7.94c-.569 0-1.03-.46-1.03-1.029V21.03A1.03 1.03 0 0 1 19.03 20h2.974v-3.018H5.996V20h2.973c.57 0 1.031.46 1.031 1.029v5.942A1.03 1.03 0 0 1 8.97 28H1.03C.462 28 0 27.54 0 26.971V21.03A1.03 1.03 0 0 1 1.03 20H4zM7.969 22H2v4l5.969.041zM26 22h-6v4h6zM17 2h-6v4h6z"
	})
});
export default SvgEdg;
